import React from 'react';
import ReactDOM from 'react-dom';
import GoogleMapReact from 'google-map-react';
import {ExploreMap} from "./ExploreMap.jsx";
import * as mapStyles from "./styles/mapStyles";

var mapOptions = {
      overviewMapControl: false,
      streetViewControl: false,
      rotateControl: true,
      mapTypeControl: true,
      mapTypeId:"satellite",
      // disable poi
      //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
      //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
      }

var mapContainerStyle =
{
   backgroundColor:"#FF0000",

}

const mapDefaultCenter = {lat: 59.95, lng: 30.33};

class Explore extends React.Component {
   constructor(props)
   {
      super(props);

  }

   render() {
      const testStyle = {
         backgroundColor:"red",
         height:300,
         width:"100%",
      }

      var mapOptions = {
      overviewMapControl: false,
      streetViewControl: false,
      rotateControl: false,
      mapTypeControl: false,
      //mapTypeId:"satellite",
      // disable poi
      //styles: [{ featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] }],
      //minZoom: DEFAULT_MIN_ZOOM, // dynamically recalculted if possible during init
      }


    //console.log("Render");
      return (
         <div style={{position:"relative", height:"50vh", width:"100%"}}>
            <ExploreMap {...this.props} />
            {/*
            <GoogleMapReact bootstrapURLKeys={{key:"AIzaSyA3jDZgzpuoyAJ41dc9Nqs6D2lNjw3Tv5w"}}
              options={mapOptions} style={{position:"relative", height:"50vh", width:"100%"}}
              
              defaultCenter={mapDefaultCenter} customMapStyle={mapStyles.googleMapJSONStyle}
              defaultZoom={10} onChange={null} />*/}

            {/*<h1>Explore Lydfelt</h1>
                        Udforsk indholdet af lydfelt.
                        <div>Logged in as user: {this.props.user ? this.props.user.name : "not logged in"}</div>
                        <ExploreMap {...this.props} topOffset={100}/>*/}
         </div>
      );
   }
}

export default Explore;


// WEBPACK FOOTER //
// ./js/Explore.jsx